import { html } from "lit-element";
import { SharedStyles } from "../../../../styles/shared-styles";
import { ModuleBase } from "../../ModuleBase/ModuleBase";

export class DrawSegmentsModule extends ModuleBase {
	Activate() {
		this.canvas.defaultCursor = "crosshair";
		this.__onDraw = this.onDraw.bind(this); //save reference to bound function to be able to deactivate
		this.canvas.on("mouse:down", this.__onDraw);
		return this;
	}
	Deactivate() {
		this.canvas.setCursor(this.canvas.defaultCursor);
		this.canvas.off("mouse:down", this.__onDraw);
	}

	onDraw(o) {
		this.Draw(this.canvas.getPointer(o.e));
		this.fireOnDraw();
	}

	Draw(pointer) {
		const strShape = this.svg.strings.reduce(a => a);
		const canvas = this.canvas;
		fabric.loadSVGFromString(strShape, function (objects, options) {
			var obj = fabric.util.groupSVGElements(objects, options);
			obj
				.scaleToHeight(200)
				.set({ left: pointer.x, top: pointer.y })
				.setCoords();
			obj.selectable = true;
			canvas.add(obj);
			canvas.renderAll();
		});
	}

	render() {
		return html`
            ${SharedStyles}
            <style>
                label {
                    display: block;
                    cursor: pointer;
                    padding: 5px;            
                }
               
                label[wide]{
                    width: 100%
                }
               
            </style>
            <label ?wide="${this.isWide}" >${this.svg}</label>`;
	}

	constructor(canvas, svg) {
		super();
		this.svg = svg;
		this.canvas = canvas;
	}
}

window.customElements.define("inspx-draw-segments-module", DrawSegmentsModule);
